import { useState } from 'react';
import { Button, Form, Card, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCogs, faTimes, faFileAlt, faPrint } from '@fortawesome/free-solid-svg-icons';
import Logo from '../assets/img/logo.svg';
import InputPhoneMobile from '../components/InputPhoneMobile';
import AchemedSimboloAzul from '../assets/img/achemed-simbolo-azul.png';

export default function ImpressoraAchemed() {
  const [customerPhone, setCustomerPhone] = useState("");
  const [showConfigModal, setShowConfigModal] = useState(false);

  const handleCloseConfigModal = () => setShowConfigModal(false);
  const handleOpenConfigModal = () => setShowConfigModal(true);

  return (
    <div className="d-flex flex-column vh-100 bg-light">
      {/* Header */}
      <div className="p-3 text-white border-bottom" style={{ background: 'linear-gradient(to right, #00468B, #3C8BBA)' }}>
        <div className="d-flex align-items-center gap-2">
          <img src={Logo} width={150} className='me-5' alt="Achemed" />
          <span className="ms-4 fs-4 fw-bold">Impressora Consultório</span>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="text-white d-flex flex-column p-3" style={{ width: '250px', background: 'linear-gradient(to bottom, #00468B, #3C8BBA)' }}>
          <div className="mb-4">
            <div className="d-flex align-items-center gap-2 p-2 rounded hover-light cursor-pointer" onClick={handleOpenConfigModal} role="button">
              <FontAwesomeIcon icon={faCogs} />
              <span>Configurações</span>
            </div>
            <div className="d-flex align-items-center gap-2 p-2 rounded hover-light cursor-pointer">
              <FontAwesomeIcon icon={faTimes} color='red' />
              <span>Fechar</span>
            </div>
          </div>

          {/* <div className="mt-auto">
            <Button variant="light" className="w-100 text-primary fw-medium">
              <FontAwesomeIcon icon={faUpload} className="me-2" />
              Enviar Arquivos
            </Button>
          </div> */}
        </div>

        {/* Formulário */}
        <div className="bg-white border-end p-4" style={{ width: '320px' }}>
          <Form>
            <Form.Group className="mb-4">
              <Form.Label className="fw-medium text-secondary">Telefone do Paciente</Form.Label>
              <InputPhoneMobile value={customerPhone} onChange={setCustomerPhone} />
            </Form.Group>


            <Form.Group>
              <Form.Label className="text-secondary fw-bold">Imprimir</Form.Label>
              <div className="d-flex flex-column gap-3 mt-2">
                {[
                  { label: 'Exame', value: 'exame', icon: faFileAlt },
                  { label: 'Medicamento', value: 'medicamento', icon: faFileAlt }
                ].map(({ label, value, icon }) => (
                  <div key={value} className="d-flex align-items-center gap-3">
                    <Button variant="outline-info" size="sm" disabled={customerPhone.replace(/\D/g, '').length < 11} title="Digital">
                      <img src={AchemedSimboloAzul} width={40} alt="Digital" />
                    </Button>
                    <Button variant="outline-info" size="sm" className='d-flex align-items-center' disabled={customerPhone.replace(/\D/g, '').length < 11} title="Digital / Papel">
                      <img src={AchemedSimboloAzul} width={40} className='me-2' alt="Digital" />
                      <FontAwesomeIcon icon={icon} size='2x' />
                    </Button>
                    <span>{label}</span>
                  </div>
                ))}

                <div className="d-flex justify-content-between align-items-center gap-3 col-10">
                  <Button variant="outline-info" size="sm" className='d-flex justify-content-center align-items-center w-100 p-2' disabled={customerPhone.replace(/\D/g, '').length < 11} title="Digital / Papel">
                    <FontAwesomeIcon icon={faPrint} size='2x' />
                  </Button>
                  <span>Outros</span>

                </div>
              </div>
            </Form.Group>
          </Form>
        </div>

        {/* Visualizador PDF */}
        <div className="flex-grow-1 p-4">
          <Card className="h-100">
            <Card.Body className="d-flex flex-column justify-content-center align-items-center text-center border border-2 border-dashed rounded bg-light">
              <FontAwesomeIcon icon={faFileAlt} size="3x" className="text-muted mb-3" />
              <h5 className="text-secondary fw-medium mb-2">Visualizador de PDF</h5>
              <p className="text-muted mb-4" style={{ maxWidth: '400px' }}>
                O arquivo PDF selecionado será exibido aqui para visualização antes do envio
              </p>

              <div className="bg-white border rounded p-3 shadow-sm d-flex align-items-center gap-2 text-muted text-sm">
                <FontAwesomeIcon icon={faFileAlt} />
                <span>documento.pdf</span>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>

      <Modal show={showConfigModal} onHide={handleCloseConfigModal}>
        <Modal.Header closeButton>
          <Modal.Title>Configurações</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Selecione o drive da impressora</Form.Label>
            <Form.Select>
              <option>Drive Padrão</option>
              <option>HP LaserJet</option>
              <option>Epson EcoTank</option>
              <option>Canon Pixma</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfigModal}>
            Fechar
          </Button>
          <Button variant="primary" onClick={handleCloseConfigModal}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}
